<div class="layout-container">
  <glxy-alert type="important" class="slug-change-static-warning">
    <strong>
      {{ 'MEETING_SCHEDULER.CALENDAR.STATIC_CHANGE_WARNING_PERSONAL' | translate }}
    </strong>
  </glxy-alert>
  <meeting-scheduler-calendar-slug-card
    [calendarId]="calendarId"
    [setInitial]="true"
    [disableButtonIfValueUnchanged]="true"
    [navigateAfterSave]="navigateAfterSave$ | async"
  ></meeting-scheduler-calendar-slug-card>
</div>
